import { useMutation, useQueryClient } from 'react-query'
import { useSvcCompareVersionsContext } from '@dc-shared-web/providers'
import { createComparison } from '@dc-shared-web/hooks/api/comparison/createComparison'
import type { CreateComparisonParams } from '@dc-shared-web/hooks/api/comparison/types'

export const useCreateComparison = () => {
  const apiClient = useSvcCompareVersionsContext()
  const queryClient = useQueryClient()

  return useMutation(
    (mutationParams: CreateComparisonParams) =>
      createComparison(apiClient, mutationParams),
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([
          'create-comparison',
          variables.crunch_uuid,
        ])
      },
    }
  )
}
